import { Clipboard } from '@angular/cdk/clipboard';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ai-response-actions',
  standalone: false,
  templateUrl: './ai-response-actions.component.html',
  styleUrl: './ai-response-actions.component.scss',
})
export class AiResponseActionsComponent {
  /** Plain text to copy to the clipboard. */
  @Input() content = '';

  /** Whether to show the thumbs-up / thumbs-down buttons. */
  @Input() showFeedbackButtons = true;

  /**
   * Pre-populated feedback state (e.g. loaded from the DB).
   * The component also updates this locally on click for an optimistic UX.
   */
  @Input() set userFeedback(val: string | null | undefined) {
    this._userFeedback = val ?? null;
  }

  get userFeedback(): string | null {
    return this._userFeedback;
  }

  private _userFeedback: string | null = null;

  /** Emitted when the user clicks a thumb button. Parent is responsible for persisting. */
  @Output() readonly thumbClicked = new EventEmitter<string>();

  copiedStatus = false;

  constructor(private clipboard: Clipboard) {}

  copy(): void {
    this.clipboard.copy(this.content);
    this.copiedStatus = true;
    setTimeout(() => {
      this.copiedStatus = false;
    }, 3000);
  }

  onThumbClick(direction: string): void {
    this._userFeedback = direction;
    this.thumbClicked.emit(direction);
  }
}
